<template>
  <svg
    @click="clicked"
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    id="map_schema"
    viewBox="0 0 3507.8741 2480.3188"
    height="210mm"
    version="1.2"
    width="297mm"
  >
    <sodipodi:namedview
      pagecolor="#ffffff"
      borderColor="#666666"
      borderopacity="1"
      objecttolerance="10"
      gridtolerance="10"
      guidetolerance="10"
      id="namedview7303"
      showgrid="false"
    />

    <rect
      style="opacity:1;fill:#ac9d93;fill-opacity:1;stroke:#342e22;stroke-width:3.2387774;stroke-linecap:butt;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
      id="rect4636"
      width="645.86542"
      height="282.9823"
      x="1737.0343"
      y="41.04266"
      ry="1.0200187e-005"
    />
    <text
      xml:space="preserve"
      style="font-style:normal;font-weight:normal;font-size:131.32099915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:0.9264276px;stroke-linecap:butt;stroke-linejoin:miter"
      x="1778.583"
      y="256.63693"
      id="text9218"
      transform="rotate(-0.12959056)"
    >
      <tspan id="tspan9220" x="1778.583" y="256.63693" style="stroke-width:0.9264276px">JÍDELNA</tspan>
    </text>
    <path
      d="m 2300.3028,379.41611 336.7516,8.81244 -4.2064,154.62308 -336.7474,-9.0414 4.2022,-154.39412"
      id="path4843"
      style="font-style:normal;font-weight:400;font-size:medium;font-family:'MS Shell Dlg 2';fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:2.95315218;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:4;stroke-dasharray:none"
    />
    <text
      transform="rotate(0.7636069)"
      id="text9222"
      y="467.95648"
      x="2349.0964"
      style="font-style:normal;font-weight:normal;font-size:91.62374115px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.13643479px;stroke-linecap:butt;stroke-linejoin:miter"
      xml:space="preserve"
    >
      <tspan y="467.95648" x="2349.0964" id="tspan9224" style="stroke-width:1.13643479px">ŠTÁB</tspan>
    </text>
    <rect
      y="1670"
      x="3300"
      height="59.151836"
      width="88.727753"
      id="rect9595"
      style="opacity:1;fill:#ac9d93;stroke:#000000;stroke-width:2.6666708;stroke-miterlimit:4;stroke-dasharray:none"
    />
    <text
      id="text9597"
      y="1650"
      x="3500"
      style="font-style:normal;font-weight:normal;font-size:42.52066803px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter"
      xml:space="preserve"
      transform="matrix(0.96750179,0.00473716,0.00473716,1.033613,0,0)"
    >
      <tspan y="1642" x="3409" id="tspan9599" style="stroke-width:1.30261779px">WC</tspan>
    </text>
    <g id="g-hut-1">
      <rect
        :style="{fill: getColor('hut-1')}"
        style="fill-rule:evenodd;stroke:#000000;stroke-width:3.70848751;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        width="185.77367"
        height="55.758148"
        x="3084.6921"
        y="1483.0685"
        transform="matrix(0.99803106,-0.06272159,0.061912,0.99808161,0,0)"
      />
      <text
        y="1532.938"
        x="3157.0686"
        style="font-style:normal;font-weight:normal;font-size:55.48526382px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#803300;fill-rule:evenodd;stroke:#ffffff;stroke-width:0;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;"
        xml:space="preserve"
        transform="rotate(-3.6276705)"
      >
        <tspan
          y="1532.938"
          x="3157.0686"
          id="tspan1987"
          style="font-size:55.48526382px;fill:#803300;stroke:#ffffff;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;"
        >1</tspan>
      </text>
      <title>{{ getTitle('hut-1') }}</title>
    </g>
    <g id="g-hut-2">
      <rect
        :style="{fill: getColor('hut-2')}"
        transform="matrix(0.99803106,-0.06272159,0.061912,0.99808161,0,0)"
        y="1559.4723"
        x="3088.23"
        height="55.758148"
        width="185.77367"
        style="fill-rule:evenodd;stroke:#000000;stroke-width:3.70848751;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:55.48526382px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#803300;fill-rule:evenodd;stroke:#ffffff;stroke-width:0;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;"
        x="3160.9358"
        y="1609.696"
        transform="rotate(-3.6276705)"
      >
        <tspan
          style="font-size:55.48526382px;line-height:28.99999917%;fill:#803300;stroke:#ffffff;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;"
          id="tspan1991"
          x="3160.9358"
          y="1609.696"
        >2</tspan>
      </text>
      <title>{{ getTitle('hut-2') }}</title>
    </g>
    <g id="g-hut-3">
      <rect
        :style="{fill: getColor('hut-3')}"
        style="fill-rule:evenodd;stroke:#000000;stroke-width:3.70848751;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        width="185.77367"
        height="55.758148"
        x="3091.7681"
        y="1635.8763"
        transform="matrix(0.99803106,-0.06272159,0.061912,0.99808161,0,0)"
      />
      <text
        y="1685.6819"
        x="3164.5728"
        style="font-style:normal;font-weight:normal;font-size:55.48526382px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#803300;fill-rule:evenodd;stroke:#ffffff;stroke-width:0;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;"
        xml:space="preserve"
        transform="rotate(-3.6276705)"
      >
        <tspan
          style="font-size:55.48526382px;line-height:28.99999917%;fill:#803300;stroke:#ffffff;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;"
          y="1685.6819"
          x="3164.5728"
          id="tspan1995"
        >3</tspan>
      </text>
      <title>{{ getTitle('hut-3') }}</title>
    </g>
    <g id="g-hut-4">
      <rect
        :style="{fill: getColor('hut-4')}"
        transform="matrix(0.99803106,-0.06272159,0.061912,0.99808161,0,0)"
        y="1712.5242"
        x="3088.8906"
        height="55.758148"
        width="185.77367"
        style="fill-rule:evenodd;stroke:#000000;stroke-width:3.70848751;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:55.48526382px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#803300;fill-rule:evenodd;stroke:#ffffff;stroke-width:0;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;"
        x="3162.0652"
        y="1762.328"
        transform="rotate(-3.6276705)"
      >
        <tspan
          style="font-size:55.48526382px;line-height:28.99999917%;fill:#803300;stroke:#ffffff;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;"
          id="tspan1999"
          x="3162.0652"
          y="1762.328"
        >4</tspan>
      </text>
      <title>{{ getTitle('hut-4') }}</title>
    </g>
    <g id="g-hut-5">
      <rect
        :style="{fill: getColor('hut-5')}"
        style="fill-rule:evenodd;stroke:#000000;stroke-width:3.70848751;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        width="185.77367"
        height="55.758148"
        x="3092.429"
        y="1788.9279"
        transform="matrix(0.99803106,-0.06272159,0.061912,0.99808161,0,0)"
      />
      <text
        y="1838.3137"
        x="3164.6318"
        style="font-style:normal;font-weight:normal;font-size:55.48526382px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#803300;fill-rule:evenodd;stroke:#ffffff;stroke-width:0;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;"
        xml:space="preserve"
        transform="rotate(-3.6276705)"
      >
        <tspan
          style="font-size:55.48526382px;line-height:28.99999917%;fill:#803300;stroke:#ffffff;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;"
          y="1838.3137"
          x="3164.6318"
          id="tspan2003"
        >5</tspan>
      </text>
      <title>{{ getTitle('hut-5') }}</title>
    </g>
    <g id="g-hut-6">
      <rect
        :style="{fill: getColor('hut-6')}"
        transform="matrix(0.99803106,-0.06272159,0.061912,0.99808161,0,0)"
        y="1953.444"
        x="3099.0842"
        height="56.117073"
        width="186.96951"
        style="fill-rule:evenodd;stroke:#000000;stroke-width:3.73236036;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:55.48526382px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#803300;fill-rule:evenodd;stroke:#ffffff;stroke-width:0;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;"
        x="3213.6895"
        y="1934.5067"
        transform="rotate(-2.3984555)"
      >
        <tspan
          style="font-size:55.48526382px;fill:#803300;stroke:#ffffff;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;"
          id="tspan2007"
          x="3213.6895"
          y="1934.5067"
        >6</tspan>
      </text>
      <title>{{ getTitle('hut-6') }}</title>
    </g>
    <g id="g-hut-7">
      <rect
        :style="{fill: getColor('hut-7')}"
        style="fill-rule:evenodd;stroke:#000000;stroke-width:3.73236036;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        width="186.96951"
        height="56.117073"
        x="3102.6035"
        y="2030.3413"
        transform="matrix(0.99803106,-0.06272159,0.061912,0.99808161,0,0)"
      />
      <text
        y="2011.3558"
        x="3218.7666"
        style="font-style:normal;font-weight:normal;font-size:55.48526382px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#803300;fill-rule:evenodd;stroke:#ffffff;stroke-width:0;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;"
        xml:space="preserve"
        transform="rotate(-2.3984555)"
      >
        <tspan
          style="font-size:55.48526382px;fill:#803300;stroke:#ffffff;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;"
          y="2011.3558"
          x="3218.7666"
          id="tspan2011"
        >7</tspan>
      </text>
      <title>{{ getTitle('hut-7') }}</title>
    </g>
    <g id="g-hut-8">
      <rect
        :style="{fill: getColor('hut-8')}"
        transform="matrix(0.99803106,-0.06272159,0.061912,0.99808161,0,0)"
        y="2107.2383"
        x="3106.1233"
        height="56.117073"
        width="186.96951"
        style="fill-rule:evenodd;stroke:#000000;stroke-width:3.73236036;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:55.48526382px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#803300;fill-rule:evenodd;stroke:#ffffff;stroke-width:0;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;"
        x="3224.1689"
        y="2088.1638"
        transform="rotate(-2.3984555)"
      >
        <tspan
          style="font-size:55.48526382px;fill:#803300;stroke:#ffffff;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;"
          id="tspan2015"
          x="3224.1689"
          y="2088.1638"
        >8</tspan>
      </text>
      <title>{{ getTitle('hut-8') }}</title>
    </g>
    <g id="g-hut-10">
      <rect
        :style="{fill: getColor('hut-10')}"
        transform="matrix(0.99803106,-0.06272159,0.061912,0.99808161,0,0)"
        y="2261.033"
        x="3113.1614"
        height="56.117073"
        width="186.96951"
        style="fill-rule:evenodd;stroke:#000000;stroke-width:3.73236036;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:55.48526382px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#803300;fill-rule:evenodd;stroke:#ffffff;stroke-width:0;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;"
        x="3214.6489"
        y="2241.4307"
        transform="rotate(-2.3984555)"
      >
        <tspan
          style="font-size:55.48526382px;fill:#803300;stroke:#ffffff;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;"
          id="tspan2019"
          x="3214.6489"
          y="2241.4307"
        >10</tspan>
      </text>
      <title>{{ getTitle('hut-10') }}</title>
    </g>
    <g id="g-hut-11">
      <rect
        :style="{fill: getColor('hut-11')}"
        style="fill-rule:evenodd;stroke:#000000;stroke-width:3.73236036;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        width="186.96951"
        height="56.117073"
        x="3116.6809"
        y="2337.9302"
        transform="matrix(0.99803106,-0.06272159,0.061912,0.99808161,0,0)"
      />
      <text
        y="2318.656"
        x="3220.8813"
        style="font-style:normal;font-weight:normal;font-size:55.48526382px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#803300;fill-rule:evenodd;stroke:#ffffff;stroke-width:0;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;"
        xml:space="preserve"
        transform="rotate(-2.3984555)"
      >
        <tspan
          style="font-size:55.48526382px;fill:#803300;stroke:#ffffff;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;"
          y="2318.656"
          x="3220.8813"
          id="tspan2023"
        >11</tspan>
      </text>
      <title>{{ getTitle('hut-11') }}</title>
    </g>
    <g id="g-hut-9">
      <rect
        :style="{fill: getColor('hut-9')}"
        style="fill-rule:evenodd;stroke:#000000;stroke-width:3.73236036;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        width="186.96951"
        height="56.117073"
        x="3109.6423"
        y="2184.1353"
        transform="matrix(0.99803106,-0.06272159,0.061912,0.99808161,0,0)"
      />
      <text
        transform="rotate(-2.3984555)"
        y="2164.9851"
        x="3229.5298"
        style="font-style:normal;font-weight:normal;font-size:55.48526382px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#803300;fill-rule:evenodd;stroke:#ffffff;stroke-width:0;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;"
        xml:space="preserve"
      >
        <tspan
          y="2164.9851"
          x="3229.5298"
          id="tspan2027"
          style="font-size:55.48526382px;fill:#803300;stroke:#ffffff;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;"
        >9</tspan>
      </text>
      <title>{{ getTitle('hut-9') }}</title>
    </g>
    <text
      xml:space="preserve"
      style="font-style:normal;font-weight:normal;font-size:77.20240784px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#784421;fill-opacity:1;fill-rule:evenodd;stroke:#ffffff;stroke-width:11.39344788;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      x="2725.0562"
      y="919.67102"
      id="c9"
    >
      <tspan
        id="tspan4617-0-1-82"
        x="2725.0562"
        y="919.67102"
        style="font-size:77.20240784px;fill:#784421;stroke:#ffffff;stroke-width:11.39344788;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      >9</tspan>
    </text>
    <text
      id="c8"
      y="677.55884"
      x="2475.0002"
      style="font-style:normal;font-weight:normal;font-size:77.20240784px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#784421;fill-opacity:1;fill-rule:evenodd;stroke:#ffffff;stroke-width:11.39344788;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      xml:space="preserve"
    >
      <tspan
        y="677.55884"
        x="2475.0002"
        id="tspan9888"
        style="font-size:77.20240784px;fill:#784421;stroke:#ffffff;stroke-width:11.39344788;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      >8</tspan>
    </text>
    <text
      xml:space="preserve"
      style="font-style:normal;font-weight:normal;font-size:77.20240784px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#784421;fill-opacity:1;fill-rule:evenodd;stroke:#f7fff7;stroke-width:11.39344788;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      x="2936.967"
      y="1145.2827"
      id="c10"
    >
      <tspan
        id="tspan4617-0-1-0"
        x="2936.967"
        y="1145.2827"
        style="font-size:77.20240784px;fill:#784421;stroke:#f7fff7;stroke-width:11.39344788;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      >10</tspan>
    </text>
    <text
      xml:space="preserve"
      style="font-style:normal;font-weight:normal;font-size:77.20240784px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#784421;fill-opacity:1;fill-rule:evenodd;stroke:#ffffff;stroke-width:11.39344788;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      x="549.96698"
      y="2136.6997"
      id="c1"
    >
      <tspan
        id="tspan4617-0-1-4"
        x="549.96698"
        y="2136.6997"
        style="font-size:77.20240784px;fill:#784421;stroke:#ffffff;stroke-width:11.39344788;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      >1</tspan>
    </text>
    <text
      xml:space="preserve"
      style="font-style:normal;font-weight:normal;font-size:77.20240784px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#784421;fill-opacity:1;fill-rule:evenodd;stroke:#ffffff;stroke-width:11.39344788;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      x="672.26526"
      y="1824.484"
      id="c2"
    >
      <tspan
        id="tspan4617-0-1-9"
        x="672.26526"
        y="1824.484"
        style="font-size:77.20240784px;fill:#784421;stroke:#ffffff;stroke-width:11.39344788;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      >2</tspan>
    </text>
    <text
      xml:space="preserve"
      style="font-style:normal;font-weight:normal;font-size:77.20240784px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#784421;fill-opacity:1;fill-rule:evenodd;stroke:#ffffff;stroke-width:11.39344788;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      x="836.79163"
      y="1518.7551"
      id="c3"
    >
      <tspan
        id="tspan4617-0-1-2"
        x="836.79163"
        y="1518.7551"
        style="font-size:77.20240784px;fill:#784421;stroke:#ffffff;stroke-width:11.39344788;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      >3</tspan>
    </text>
    <text
      xml:space="preserve"
      style="font-style:normal;font-weight:normal;font-size:77.20240784px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#784421;fill-opacity:1;fill-rule:evenodd;stroke:#ffffff;stroke-width:11.39344788;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      x="977.39148"
      y="1197.7566"
      id="c4"
    >
      <tspan
        id="tspan4617-0-1-8"
        x="977.39148"
        y="1197.7566"
        style="font-size:77.20240784px;fill:#784421;stroke:#ffffff;stroke-width:11.39344788;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      >4</tspan>
    </text>
    <text
      id="c12"
      y="532.24359"
      x="1698.2855"
      style="font-style:normal;font-weight:normal;font-size:77.20240784px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#784421;fill-opacity:1;fill-rule:evenodd;stroke:#ffffff;stroke-width:11.39344788;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      xml:space="preserve"
    >
      <tspan
        y="532.24359"
        x="1698.2855"
        id="tspan9862-1"
        style="font-size:77.20240784px;fill:#784421;stroke:#ffffff;stroke-width:11.39344788;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      >12</tspan>
    </text>
    <text
      xml:space="preserve"
      style="font-style:normal;font-weight:normal;font-size:77.20240784px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#784421;fill-opacity:1;fill-rule:evenodd;stroke:#ffffff;stroke-width:11.39344788;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      x="1200.6897"
      y="996.37701"
      id="c5"
    >
      <tspan
        id="tspan4617-0-1-48"
        x="1200.6897"
        y="996.37701"
        style="font-size:77.20240784px;fill:#784421;stroke:#ffffff;stroke-width:11.39344788;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      >5</tspan>
    </text>
    <text
      id="c11"
      y="438.52573"
      x="2836.0254"
      style="font-style:normal;font-weight:normal;font-size:77.20240784px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#784421;fill-opacity:1;fill-rule:evenodd;stroke:#ffffff;stroke-width:11.39344788;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill"
      xml:space="preserve"
    >
      <tspan
        y="438.52573"
        x="2836.0254"
        id="tspan9862-1-5"
        style="font-size:77.20240784px;fill:#784421;stroke:#ffffff;stroke-width:11.39344788;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill"
      >11</tspan>
    </text>
    <text
      id="c6"
      y="773.1767"
      x="1472.0948"
      style="font-style:normal;font-weight:normal;font-size:77.20240784px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#784421;fill-opacity:1;fill-rule:evenodd;stroke:#ffffff;stroke-width:11.39344788;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      xml:space="preserve"
    >
      <tspan
        y="773.1767"
        x="1472.0948"
        id="tspan9862"
        style="font-size:77.20240784px;fill:#784421;stroke:#ffffff;stroke-width:11.39344788;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke markers fill;"
      >6</tspan>
    </text>
    <path
      id="path6797"
      d="m 418.35317,2028.7963 259.55997,-112.324 -19.16893,-44.2958 -259.55994,112.3241 z"
      style="opacity:1;fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
    />
    <path
      id="path6799"
      d="m 418.35317,2028.7963 -19.1689,-44.2957 -106.93766,46.2771 19.16891,44.2957 z"
      style="opacity:1;fill:#ac9d93;fill-opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
    />
    <path
      id="path6801"
      d="m 622.50073,1887.8886 36.23032,-15.6786 -52.34048,-120.949 -36.23031,15.6786 z"
      style="opacity:1;fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
    />
    <g id="g-cottage-2-1">
      <path
        :style="{fill: getColor('cottage-2-1')}"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        d="m 399.20421,1984.5198 -52.34047,-120.9491 -106.92402,46.2712 52.34047,120.9491 z"
      />
      <text
        transform="rotate(-23.400459)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261767px;stroke-linecap:butt;stroke-linejoin:miter"
        x="-501.78229"
        y="1928.2146"
      >
        <tspan
          id="tspan6851"
          x="-501.78229"
          y="1928.2146"
          style="font-size:45.5737915px;stroke-width:1.30261767px"
        >1</tspan>
      </text>
      <title>{{ getTitle('cottage-2-1') }}</title>
    </g>
    <g id="g-cottage-2-2">
      <path
        :style="{fill: getColor('cottage-2-2')}"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        d="m 458.90116,1815.0867 -112.03742,48.484 52.34047,120.9491 112.03745,-48.484 z"
      />
      <text
        transform="rotate(-23.400459)"
        y="1928.4211"
        x="-382.2355"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261767px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan
          style="font-size:45.5737915px;stroke-width:1.30261767px"
          y="1928.4211"
          x="-382.2355"
          id="tspan6855"
        >2</tspan>
      </text>
      <title>{{ getTitle('cottage-2-2') }}</title>
    </g>
    <text
      xml:space="preserve"
      style="font-style:normal;font-weight:normal;font-size:40.05714035px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261779px;stroke-linecap:butt;stroke-linejoin:miter"
      x="-1553.8024"
      y="-185.92902"
      id="text6929"
      transform="matrix(-0.50081995,-1.1573012,0.72778609,-0.31494806,0,0)"
    >
      <tspan id="tspan6931" x="-1553.8024" y="-185.92902" style="stroke-width:1.30261779px">WC</tspan>
    </text>
    <g id="g-cottage-2-3">
      <path
        :style="{fill: getColor('cottage-2-3')}"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        d="m 458.90116,1815.0867 52.3405,120.9491 111.25907,-48.1472 -52.34047,-120.949 z"
      />
      <text
        transform="rotate(-23.400459)"
        y="1928.1748"
        x="-260.46194"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261767px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan
          style="font-size:45.5737915px;stroke-width:1.30261767px"
          y="1928.1748"
          x="-260.46194"
          id="tspan6859"
        >3</tspan>
      </text>
      <title>{{ getTitle('cottage-2-3') }}</title>
    </g>
    <path
      style="opacity:1;fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
      d="m 555.82481,1690.4562 271.67918,-78.6034 -13.41423,-46.3639 -271.67919,78.6033 z"
      id="path6937"
    />
    <path
      style="opacity:1;fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
      d="m 776.15048,1576.4921 37.92196,-10.9718 -36.6274,-126.5962 -37.92197,10.9717 z"
      id="path6941"
    />
    <text
      transform="matrix(-0.35046938,-1.2113374,0.76176737,-0.22039787,0,0)"
      id="text7069"
      y="426.81006"
      x="-1355.7501"
      style="font-style:normal;font-weight:normal;font-size:40.05714417px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261779px;stroke-linecap:butt;stroke-linejoin:miter"
      xml:space="preserve"
    >
      <tspan y="426.81006" x="-1355.7501" id="tspan7071" style="stroke-width:1.30261779px">WC</tspan>
    </text>
    <g id="g-cottage-3-1">
      <path
        :style="{fill: getColor('cottage-3-1')}"
        d="m 542.42793,1644.1138 -36.62741,-126.5964 -111.91646,32.3802 36.6274,126.5964 z"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        transform="rotate(-16.136444)"
        y="1678.1"
        x="-15.94783"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261779px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan
          style="font-size:45.5737915px;stroke-width:1.30261779px"
          y="1678.1"
          x="-15.94783"
          id="tspan6991"
        >1</tspan>
      </text>
      <title>{{ getTitle('cottage-3-1') }}</title>
    </g>
    <g id="g-cottage-3-4">
      <path
        :style="{fill: getColor('cottage-3-4')}"
        d="m 555.82481,1690.4562 -13.41424,-46.364 -111.93073,32.3844 13.41424,46.3639 z"
        style="opacity:1;fill:#dcc59b;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        transform="rotate(-16.136444)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261779px;stroke-linecap:butt;stroke-linejoin:miter"
        x="-15.711519"
        y="1768.3082"
      >
        <tspan
          id="tspan6995"
          x="-15.711519"
          y="1768.3082"
          style="font-size:45.5737915px;stroke-width:1.30261779px"
        >4</tspan>
      </text>
      <title>{{ getTitle('cottage-3-4') }}</title>
    </g>
    <g id="g-cottage-3-2">
      <path
        :style="{fill: getColor('cottage-3-2')}"
        d="m 623.06915,1483.5888 -117.26863,33.9286 36.62741,126.5964 117.26863,-33.9287 z"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        transform="rotate(-16.136444)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261779px;stroke-linecap:butt;stroke-linejoin:miter"
        x="103.71822"
        y="1678.0601"
      >
        <tspan
          id="tspan6999"
          x="103.71822"
          y="1678.0601"
          style="font-size:45.5737915px;stroke-width:1.30261779px"
        >2</tspan>
      </text>
      <title>{{ getTitle('cottage-3-2') }}</title>
    </g>
    <g id="g-cottage-3-3">
      <path
        :style="{fill: getColor('cottage-3-3')}"
        d="m 623.06915,1483.5888 36.62741,126.5963 116.45392,-33.693 -36.62741,-126.5963 z"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        transform="rotate(-16.136444)"
        y="1678.0601"
        x="225.6505"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261779px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan
          style="font-size:45.5737915px;stroke-width:1.30261779px"
          y="1678.0601"
          x="225.6505"
          id="tspan7003"
        >3</tspan>
      </text>
      <title>{{ getTitle('cottage-3-3') }}</title>
    </g>
    <path
      id="path7077"
      d="m 699.72799,1368.0516 270.24323,-83.4067 -14.23395,-46.119 -270.24323,83.4067 z"
      style="opacity:1;fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.47365236;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
    />
    <path
      id="path7081"
      d="m 917.99895,1250.2001 37.72155,-11.6423 -38.86563,-125.9272 -37.72153,11.6423 z"
      style="opacity:1;fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.47365236;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
    />
    <text
      xml:space="preserve"
      style="font-style:normal;font-weight:normal;font-size:40.05713654px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261767px;stroke-linecap:butt;stroke-linejoin:miter"
      x="-1145.7831"
      y="680.3396"
      id="text7209"
      transform="matrix(-0.37188578,-1.2049348,0.75774109,-0.2338659,0,0)"
    >
      <tspan id="tspan7211" x="-1145.7831" y="680.3396" style="stroke-width:1.30261767px">WC</tspan>
    </text>
    <g id="g-cottage-4-1">
      <path
        :style="{fill: getColor('cottage-4-1')}"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.47365236;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        d="m 685.51178,1321.9539 -38.86561,-125.9272 -111.32494,34.3588 38.86564,125.9273 z"
      />
      <text
        transform="rotate(-17.15209)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261755px;stroke-linecap:butt;stroke-linejoin:miter"
        x="185.69037"
        y="1415.3861"
      >
        <tspan
          id="tspan7131"
          x="185.69037"
          y="1415.3861"
          style="font-size:45.5737915px;stroke-width:1.30261755px"
        >1</tspan>
      </text>
      <title>{{ getTitle('cottage-4-1') }}</title>
    </g>
    <g id="g-cottage-4-4">
      <path
        :style="{fill: getColor('cottage-4-4')}"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.47365236;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        d="m 699.72799,1368.0516 -14.23395,-46.119 -111.33911,34.3632 14.23395,46.1191 z"
      />
      <text
        transform="rotate(-17.15209)"
        y="1505.5942"
        x="185.92673"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261755px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan
          style="font-size:45.5737915px;stroke-width:1.30261755px"
          y="1505.5942"
          x="185.92673"
          id="tspan7135"
        >4</tspan>
      </text>
      <title>{{ getTitle('cottage-4-4') }}</title>
    </g>
    <g id="g-cottage-4-2">
      <path
        :style="{fill: getColor('cottage-4-2')}"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.47365236;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        d="m 763.29496,1160.0247 -116.64879,36.002 38.86561,125.9272 116.64881,-36.0019 z"
      />
      <text
        transform="rotate(-17.15209)"
        y="1415.3464"
        x="305.35678"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261755px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan
          style="font-size:45.5737915px;stroke-width:1.30261755px"
          y="1415.3464"
          x="305.35678"
          id="tspan7139"
        >2</tspan>
      </text>
      <title>{{ getTitle('cottage-4-2') }}</title>
    </g>
    <g id="g-cottage-4-3">
      <path
        :style="{fill: getColor('cottage-4-3')}"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.47365236;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        d="m 763.29496,1160.0247 38.86563,125.9273 115.83836,-35.7519 -38.86561,-125.9272 z"
      />
      <text
        transform="rotate(-17.15209)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261755px;stroke-linecap:butt;stroke-linejoin:miter"
        x="427.28912"
        y="1415.3464"
      >
        <tspan
          id="tspan7143"
          x="427.28912"
          y="1415.3464"
          style="font-size:45.5737915px;stroke-width:1.30261755px"
        >3</tspan>
      </text>
      <title>{{ getTitle('cottage-4-3') }}</title>
    </g>
    <path
      style="opacity:1;fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
      d="m 880.78688,1087.4133 282.75032,6.3464 1.0832,-48.2533 -282.75046,-6.3465 z"
      id="path7217"
    />
    <path
      style="opacity:1;fill:#ac9d93;fill-opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
      d="m 880.78688,1087.4133 1.08306,-48.2534 -116.49202,-2.6146 -1.08307,48.2533 z"
      id="path7219"
    />
    <path
      style="opacity:1;fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
      d="m 1125.1271,1044.6455 39.4673,0.8859 2.9573,-131.75536 -39.4673,-0.88586 z"
      id="path7221"
    />
    <text
      transform="matrix(0.02829694,-1.2607006,0.79281032,0.01779495,0,0)"
      id="text7349"
      y="1487.1515"
      x="-791.95172"
      style="font-style:normal;font-weight:normal;font-size:40.05713654px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261767px;stroke-linecap:butt;stroke-linejoin:miter"
      xml:space="preserve"
    >
      <tspan y="1487.1515" x="-791.95172" id="tspan7351" style="stroke-width:1.30261767px">WC</tspan>
    </text>
    <path
      id="path7357"
      d="m 1146.9891,834.43198 282.2569,17.86539 3.0488,-48.1691 -282.2569,-17.86544 z"
      style="opacity:1;fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
    />
    <path
      id="path7361"
      d="m 1392.8694,801.6584 39.3985,2.49372 8.3248,-131.52529 -39.3984,-2.49371 z"
      style="opacity:1;fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
    />
    <text
      xml:space="preserve"
      style="font-style:normal;font-weight:normal;font-size:40.05714417px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261779px;stroke-linecap:butt;stroke-linejoin:miter"
      x="-548.44733"
      y="1855.924"
      id="text7489"
      transform="matrix(0.07965672,-1.2584998,0.79142621,0.05009331,0,0)"
    >
      <tspan id="tspan7491" x="-548.44733" y="1855.924" style="stroke-width:1.30261779px">WC</tspan>
    </text>
    <g id="g-cottage-6-1">
      <path
        :style="{fill: getColor('cottage-6-1')}"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        d="m 1150.047,786.28896 8.3249,-131.52528 -116.2739,-7.35955 -8.3248,131.52528 z"
      />
      <text
        transform="rotate(3.6217026)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261779px;stroke-linecap:butt;stroke-linejoin:miter"
        x="1119.3152"
        y="664.63696"
      >
        <tspan
          id="tspan7411"
          x="1119.3152"
          y="664.63696"
          style="font-size:45.5737915px;stroke-width:1.30261779px"
        >1</tspan>
      </text>
      <title>{{ getTitle('cottage-6-1') }}</title>
    </g>
    <g id="g-cottage-6-4">
      <path
        :style="{fill: getColor('cottage-6-4')}"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        d="m 1146.9891,834.43198 3.0488,-48.16915 -116.2886,-7.36048 -3.0489,48.16915 z"
      />
      <text
        transform="rotate(3.6217026)"
        y="754.84546"
        x="1119.5514"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261779px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan
          style="font-size:45.5737915px;stroke-width:1.30261779px"
          y="754.84546"
          x="1119.5514"
          id="tspan7415"
        >4</tspan>
      </text>
      <title>{{ getTitle('cottage-6-4') }}</title>
    </g>
    <g id="g-cottage-6-2">
      <path
        :style="{fill: getColor('cottage-6-2')}"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        d="m 1280.2062,662.4752 -121.8343,-7.71152 -8.3249,131.52528 121.8344,7.71151 z"
      />
      <text
        transform="rotate(3.6217026)"
        y="664.59717"
        x="1238.9811"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261779px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan
          style="font-size:45.5737915px;stroke-width:1.30261779px"
          y="664.59717"
          x="1238.9811"
          id="tspan7419"
        >2</tspan>
        <tspan
          id="tspan1241"
          style="font-size:45.5737915px;stroke-width:1.30261779px"
          y="664.59717"
          x="1238.9811"
        />
      </text>
      <title>{{ getTitle('cottage-6-2') }}</title>
    </g>
    <g id="g-cottage-6-3">
      <path
        :style="{fill: getColor('cottage-6-3')}"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        d="m 1280.2062,662.4752 -8.3248,131.52527 120.988,7.65793 8.3249,-131.52528 z"
      />
      <text
        transform="rotate(3.6217026)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261779px;stroke-linecap:butt;stroke-linejoin:miter"
        x="1360.9136"
        y="664.59717"
      >
        <tspan
          id="tspan7423"
          x="1360.9136"
          y="664.59717"
          style="font-size:45.5737915px;stroke-width:1.30261779px"
        >3</tspan>
      </text>
      <title>{{ getTitle('cottage-6-3') }}</title>
    </g>
    <path
      style="opacity:1;fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.40288854;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
      d="m 3331.9318,1221.998 -276.8404,-11.033 1.8829,-47.2447 276.8404,11.033 z"
      id="path8396"
    />
    <path
      style="opacity:1;fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.40288854;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
      d="m 3331.9318,1221.998 1.8829,-47.2447 114.057,4.5456 -1.8828,47.2447 z"
      id="path8398"
    />
    <path
      style="opacity:1;fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.40288854;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
      d="m 3095.6405,1165.2862 -38.6423,-1.5399 5.1411,-129.0011 38.6423,1.54 z"
      id="path8400"
    />
    <text
      transform="matrix(0.05021583,-1.260018,0.79238093,0.03157899,0,0)"
      id="text8528"
      y="3949.2673"
      x="-809.69171"
      style="font-style:normal;font-weight:normal;font-size:39.24111176px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.27608132px;stroke-linecap:butt;stroke-linejoin:miter"
      xml:space="preserve"
    >
      <tspan y="3949.2673" x="-809.69171" id="tspan8530" style="stroke-width:1.27608132px">WC</tspan>
    </text>
    <g id="g-cottage-10-2">
      <path
        :style="{fill: getColor('cottage-10-2')}"
        d="m 3333.8032,1174.7779 5.1412,-129.0011 114.0424,4.5449 -5.141,129.0011 z"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.40288854;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        transform="rotate(2.2822177)"
        y="995.41901"
        x="3415.9807"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.2760812px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan
          style="font-size:45.5737915px;stroke-width:1.2760812px"
          y="995.41901"
          x="3415.9807"
          id="tspan8506"
        >2</tspan>
      </text>
      <title>{{ getTitle('cottage-10-2') }}</title>
    </g>
    <g id="g-cottage-10-1">
      <path
        :style="{fill: getColor('cottage-10-1')}"
        d="m 3100.7848,1036.2874 -5.1465,129.0003 238.1624,9.4879 5.1411,-128.9992 z"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.40288854;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        transform="rotate(2.2822177)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.2760812px;stroke-linecap:butt;stroke-linejoin:miter"
        x="3239.4866"
        y="995.21698"
      >
        <tspan
          id="tspan8510"
          x="3239.4866"
          y="995.21698"
          style="font-size:45.5737915px;stroke-width:1.2760812px"
        >1</tspan>
      </text>
      <title>{{ getTitle('cottage-10-1') }}</title>
    </g>
    <path
      id="path8534"
      d="m 3078.9209,986.77084 -276.9232,-8.70868 1.4862,-47.25886 276.9232,8.70859 z"
      style="opacity:1;fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.40288925;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
    />
    <path
      id="path8536"
      d="m 3078.9209,986.77084 1.4862,-47.25895 114.0913,3.58793 -1.4862,47.25895 z"
      style="opacity:1;fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.40288925;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
    />
    <path
      id="path8538"
      d="m 2842.162,932.04473 -38.6541,-1.21573 4.0581,-129.0399 38.654,1.21559 z"
      style="opacity:1;fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.40288925;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
    />
    <text
      xml:space="preserve"
      style="font-style:normal;font-weight:normal;font-size:39.24111938px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.27608132px;stroke-linecap:butt;stroke-linejoin:miter"
      x="-652.00958"
      y="3609.3762"
      id="text8666"
      transform="matrix(0.03963652,-1.2603951,0.79261814,0.02492601,0,0)"
    >
      <tspan id="tspan8668" x="-652.00958" y="3609.3762" style="stroke-width:1.27608132px">WC</tspan>
    </text>
    <g id="g-cottage-9-2">
      <path
        :style="{fill: getColor('cottage-9-2')}"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.40288925;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        d="m 2964.9217,806.73757 119.5322,3.75909 -4.058,129.03993 -119.5322,-3.7591 z"
      />
      <text
        transform="rotate(1.8012268)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.27608144px;stroke-linecap:butt;stroke-linejoin:miter"
        x="3029.2166"
        y="796.09668"
      >
        <tspan
          id="tspan8644"
          x="3029.2166"
          y="796.09668"
          style="font-size:45.5737915px;stroke-width:1.27608144px"
        >2</tspan>
      </text>
      <title>{{ getTitle('cottage-9-2') }}</title>
    </g>
    <g id="g-cottage-9-1">
      <path
        :style="{fill: getColor('cottage-9-1')}"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.40288925;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        d="m 2964.9217,806.73757 -4.058,129.03992 -118.7017,-3.73276 4.058,-129.04004 z"
      />
      <text
        transform="rotate(1.8012268)"
        y="795.8941"
        x="2909.7915"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.27608144px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan
          style="font-size:45.5737915px;stroke-width:1.27608144px"
          y="795.8941"
          x="2909.7915"
          id="tspan8648"
        >1</tspan>
      </text>
      <title>{{ getTitle('cottage-9-1') }}</title>
    </g>
    <g id="g-cottage-9-3">
      <path
        :style="{fill: getColor('cottage-9-3')}"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.40288925;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        d="m 3080.3959,939.53659 4.058,-129.03993 114.0767,3.5874 -4.058,129.03991 z"
      />
      <text
        transform="rotate(1.8012268)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.27608144px;stroke-linecap:butt;stroke-linejoin:miter"
        x="3146.1958"
        y="795.85516"
      >
        <tspan
          id="tspan8656"
          x="3146.1958"
          y="795.85516"
          style="font-size:45.5737915px;stroke-width:1.27608144px"
        >3</tspan>
      </text>
      <title>{{ getTitle('cottage-9-3') }}</title>
    </g>
    <path
      style="opacity:1;fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.40288901;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
      d="m 2821.4032,764.58388 -277.016,-4.94468 0.8438,-47.27476 277.016,4.94468 z"
      id="path8672"
    />
    <path
      style="opacity:1;fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.40288901;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
      d="m 2583.9223,713.08008 -38.6668,-0.69021 2.3041,-129.08317 38.6669,0.69018 z"
      id="path8676"
    />
    <text
      transform="matrix(0.02250527,-1.2608174,0.79288363,0.01415278,0,0)"
      id="text8804"
      y="3264.0869"
      x="-512.9184"
      style="font-style:normal;font-weight:normal;font-size:39.24111557px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.27608144px;stroke-linecap:butt;stroke-linejoin:miter"
      xml:space="preserve"
    >
      <tspan y="3264.0869" x="-512.9184" id="tspan8806" style="stroke-width:1.27608144px">WC</tspan>
    </text>
    <g id="g-cottage-8-2">
      <path
        :style="{fill: getColor('cottage-8-2')}"
        d="m 2704.9679,586.11638 119.5724,2.13434 -2.3042,129.08318 -119.5722,-2.13433 z"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.40288901;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        transform="rotate(1.0226063)"
        y="620.60901"
        x="2755.3345"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.27608144px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan
          style="font-size:45.5737915px;stroke-width:1.27608144px"
          y="620.60901"
          x="2755.3345"
          id="tspan8782"
        >2</tspan>
      </text>
      <title>{{ getTitle('cottage-8-2') }}</title>
    </g>
    <g id="g-cottage-8-1">
      <path
        :style="{fill: getColor('cottage-8-1')}"
        d="m 2704.9679,586.11638 -2.304,129.08319 -118.7416,-2.11949 2.3042,-129.0832 z"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.40288901;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        transform="rotate(1.0226063)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.27608144px;stroke-linecap:butt;stroke-linejoin:miter"
        x="2635.9092"
        y="620.40649"
      >
        <tspan
          id="tspan8786"
          x="2635.9092"
          y="620.40649"
          style="font-size:45.5737915px;stroke-width:1.27608144px"
        >1</tspan>
      </text>
      <title>{{ getTitle('cottage-8-1') }}</title>
    </g>
    <g id="g-cottage-8-4">
      <path
        :style="{fill: getColor('cottage-8-4')}"
        d="m 2821.4032,764.58388 0.8438,-47.27476 114.1295,2.03717 -0.8438,47.27473 z"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.40288901;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        transform="rotate(1.0226063)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.27608144px;stroke-linecap:butt;stroke-linejoin:miter"
        x="2872.6038"
        y="708.53558"
      >
        <tspan
          id="tspan8790"
          x="2872.6038"
          y="708.53558"
          style="font-size:45.5737915px;stroke-width:1.27608144px"
        >4</tspan>
      </text>
      <title>{{ getTitle('cottage-8-4') }}</title>
    </g>
    <g id="g-cottage-8-3">
      <path
        :style="{fill: getColor('cottage-8-3')}"
        d="m 2822.2361,717.3339 2.3042,-129.08318 114.1148,2.03693 -2.304,129.08317 z"
        style="opacity:1;fill-opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.40288901;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
      />
      <text
        transform="rotate(1.0226063)"
        y="620.36755"
        x="2872.3132"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.27608144px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan
          style="font-size:45.5737915px;stroke-width:1.27608144px"
          y="620.36755"
          x="2872.3132"
          id="tspan8794"
        >3</tspan>
      </text>
      <title>{{ getTitle('cottage-8-3') }}</title>
    </g>
    <path
      style="font-style:normal;font-weight:400;font-size:medium;font-family:'MS Shell Dlg 2';fill:#ac9d93;fill-opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.40288877;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:4;stroke-dasharray:none"
      d="m 2803.6029,378.90574 -115.1219,-64.09223 -30.8678,55.9198 114.779,64.10304 z"
    />
    <path
      style="font-style:normal;font-weight:400;font-size:medium;font-family:'MS Shell Dlg 2';fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.40288877;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:4;stroke-dasharray:none"
      d="m 2810.6381,94.103092 -40.1825,-21.450317 -153.4466,275.401955 39.4891,22.05418 z"
      id="path12932"
    />
    <g id="g-cottage-11-1">
      <path
        :style="{fill: getColor('cottage-11-1')}"
        d="m 2834.8931,322.83306 -115.3865,-64.23328 -31.0256,56.21369 115.1219,64.09221 z"
        style="font-style:normal;font-weight:400;font-size:medium;font-family:'MS Shell Dlg 2';fill-rule:evenodd;stroke:#000000;stroke-width:3.40288877;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:4;stroke-dasharray:none"
      />
      <text
        transform="rotate(-60.966141)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.32319975px;stroke-linecap:butt;stroke-linejoin:miter"
        x="1046.349"
        y="2579.0435"
      >
        <tspan
          id="tspan7966"
          x="1046.349"
          y="2579.0435"
          style="font-size:45.5737915px;stroke-width:1.32319975px"
        >1</tspan>
      </text>
      <title>{{ getTitle('cottage-11-1') }}</title>
    </g>
    <g id="g-cottage-11-4">
      <path
        :style="{fill: getColor('cottage-11-4')}"
        d="m 2926.5049,159.44174 35.0394,-63.570208 -77.8051,-43.45342 -35.2079,63.146138 z"
        style="font-style:normal;font-weight:400;font-size:medium;font-family:'MS Shell Dlg 2';fill-rule:evenodd;stroke:#000000;stroke-width:3.40288877;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:4;stroke-dasharray:none"
      />
      <text
        transform="rotate(-60.966141)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.32319975px;stroke-linecap:butt;stroke-linejoin:miter"
        x="1299.7678"
        y="2604.2295"
      >
        <tspan
          id="tspan48"
          x="1299.7678"
          y="2604.2295"
          style="font-size:45.5737915px;stroke-width:1.32319975px"
        >4</tspan>
      </text>
      <title>{{ getTitle('cottage-11-4') }}</title>
    </g>
    <g id="g-cottage-11-5">
      <path
        :style="{fill: getColor('cottage-11-5')}"
        d="m 2805.9341,8.9646888 77.8051,43.4534232 -35.2079,63.146138 -78.0758,-42.911523 z"
        style="font-style:normal;font-weight:400;font-size:medium;font-family:'MS Shell Dlg 2';fill-rule:evenodd;stroke:#000000;stroke-width:3.40288877;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:4;stroke-dasharray:none"
      />
      <text
        transform="rotate(-60.966141)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5738px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.3232px;stroke-linecap:butt;stroke-linejoin:miter"
        x="1301.6205"
        y="2517.4219"
      >
        <tspan
          id="tspan481"
          x="1301.6205"
          y="2517.4219"
          style="font-size:45.5737915px;stroke-width:1.32319975px"
        >5</tspan>
      </text>
      <title>{{ getTitle('cottage-11-5') }}</title>
    </g>
    <g id="g-cottage-11-2">
      <path
        :style="{fill: getColor('cottage-11-2')}"
        d="m 2866.1832,266.76042 -115.6482,-64.37937 -31.0285,56.2187 115.3865,64.23327 z"
        style="font-style:normal;font-weight:400;font-size:medium;font-family:'MS Shell Dlg 2';fill-rule:evenodd;stroke:#000000;stroke-width:3.40288877;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:4;stroke-dasharray:none"
      />
      <text
        transform="rotate(-60.966141)"
        y="2578.7861"
        x="1110.6812"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.32319975px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan
          style="font-size:45.5737915px;stroke-width:1.32319975px"
          y="2578.7861"
          x="1110.6812"
          id="tspan8169"
        >2</tspan>
      </text>
      <title>{{ getTitle('cottage-11-2') }}</title>
    </g>
    <g id="g-cottage-11-3">
      <path
        :style="{fill: getColor('cottage-11-3')}"
        d="M 2926.6073,158.47589 2810.638,94.103212 2750.5359,202.37996 2866.1841,266.75933 Z"
        style="font-style:normal;font-weight:400;font-size:medium;font-family:'MS Shell Dlg 2';fill-rule:evenodd;stroke:#000000;stroke-width:3.40288877;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:4;stroke-dasharray:none"
      />
      <text
        transform="rotate(-60.966141)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.32319975px;stroke-linecap:butt;stroke-linejoin:miter"
        x="1205.0269"
        y="2578.894"
      >
        <tspan
          id="tspan8173"
          x="1205.0269"
          y="2578.894"
          style="font-size:45.5737915px;stroke-width:1.32319975px"
        >3</tspan>
      </text>
      <title>{{ getTitle('cottage-11-3') }}</title>
    </g>
    <path
      style="font-style:normal;font-weight:400;font-size:medium;font-family:'MS Shell Dlg 2';fill:#ac9d93;fill-opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.39586449;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:4;stroke-dasharray:none"
      d="m 1259.354,464.5616 172.0651,5.95866 2.2933,-65.72741 -171.7042,-6.67557 z"
    />
    <path
      style="font-style:normal;font-weight:400;font-size:medium;font-family:'MS Shell Dlg 2';fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.57738686;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:4;stroke-dasharray:none"
      d="m 1433.8004,404.88668 -1.2446,35.90146 140.1133,5.00937 -5.2741,141.45017 29.9795,1.18045 6.605,-176.94661 z"
      id="path2071"
    />
    <g id="g-cottage-12-4">
      <path
        :style="{fill: getColor('cottage-12-4')}"
        d="m 1501.5534,443.25609 -68.9969,-2.46771 -4.8775,140.96143 68.6375,2.70341 z"
        style="font-style:normal;font-weight:400;font-size:medium;font-family:'MS Shell Dlg 2';fill-rule:evenodd;stroke:#000000;stroke-width:3.57738686;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:4;stroke-dasharray:none"
      />
      <text
        y="480.97409"
        x="1462.5997"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.32319987px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
        transform="rotate(1.9980188)"
      >
        <tspan
          style="font-size:45.5737915px;stroke-width:1.32319987px"
          y="480.97409"
          x="1462.5997"
          id="tspan13086"
        >4</tspan>
      </text>
      <title>{{ getTitle('cottage-12-4') }}</title>
    </g>
    <g id="g-cottage-12-6">
      <path
        :style="{fill: getColor('cottage-12-6')}"
        d="m 1333.0076,403.47519 -2.3668,59.15629 85.3436,3.37541 7.1025,0.28183 2.0802,-59.62167 z"
        style="font-style:normal;font-weight:400;font-size:medium;font-family:'MS Shell Dlg 2';fill-rule:evenodd;stroke:#000000;stroke-width:3.57738686;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:4;stroke-dasharray:none"
      />
      <text
        x="1376.9598"
        y="402.50516"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.32319987px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
        transform="rotate(1.9980188)"
      >
        <tspan
          style="font-size:45.5737915px;stroke-width:1.32319987px"
          x="1376.9598"
          y="402.50516"
          id="tspan13086"
        >6</tspan>
      </text>
      <title>{{ getTitle('cottage-12-6') }}</title>
    </g>
    <g id="g-cottage-12-3">
      <path
        :style="{fill: getColor('cottage-12-3')}"
        d="m 1501.5534,443.25609 -5.2356,141.19697 71.067,2.79449 5.2742,-141.45015 z"
        style="font-style:normal;font-weight:400;font-size:medium;font-family:'MS Shell Dlg 2';fill-rule:evenodd;stroke:#000000;stroke-width:3.57738686;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        transform="rotate(1.9980188)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.32319987px;stroke-linecap:butt;stroke-linejoin:miter"
        x="1538.9012"
        y="480.73483"
      >
        <tspan
          id="tspan14593"
          x="1538.9012"
          y="480.73483"
          style="font-size:45.5737915px;stroke-width:1.32319987px"
        >3</tspan>
      </text>
      <title>{{ getTitle('cottage-12-3') }}</title>
    </g>
    <g id="g-cottage-12-2">
      <path
        :style="{fill: getColor('cottage-12-2')}"
        d="m 1603.9742,411.48175 -4.1168,109.80624 70.185,2.1843 4.396,-109.25821 z"
        style="font-style:normal;font-weight:400;font-size:medium;font-family:'MS Shell Dlg 2';fill-rule:evenodd;stroke:#000000;stroke-width:3.57738686;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        transform="rotate(1.9980188)"
        y="429.62869"
        x="1633.7706"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.32319987px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan
          style="font-size:45.5737915px;stroke-width:1.32319987px"
          y="429.62869"
          x="1633.7706"
          id="tspan14597"
        >2</tspan>
      </text>
      <title>{{ getTitle('cottage-12-2') }}</title>
    </g>
    <g id="g-cottage-12-1">
      <path
        :style="{fill: getColor('cottage-12-1')}"
        d="m 1670.0536,523.47272 -70.1848,-2.18432 -2.5172,67.13928 69.9652,2.75318 z"
        style="font-style:normal;font-weight:400;font-size:medium;font-family:'MS Shell Dlg 2';fill-rule:evenodd;stroke:#000000;stroke-width:3.57738686;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        transform="rotate(1.9980188)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.32319987px;stroke-linecap:butt;stroke-linejoin:miter"
        x="1638.726"
        y="517.97113"
      >
        <tspan
          id="tspan14601"
          x="1638.726"
          y="517.97113"
          style="font-size:45.5737915px;stroke-width:1.32319987px"
        >1</tspan>
      </text>
      <title>{{ getTitle('cottage-12-1') }}</title>
    </g>
    <path
      id="path9096"
      d="M 308.15882,2343.6469 560.2226,2238.4722 541.63428,2193.923 289.5705,2299.0978 Z"
      style="opacity:1;fill:#ac9d93;fill-opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.47365236;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
    />
    <path
      id="path9100"
      d="m 505.18803,2209.1619 36.43293,-15.2018 -50.74878,-121.6254 -36.43292,15.2018 z"
      style="opacity:1;fill:#ac9d93;fill-rule:evenodd;stroke:#000000;stroke-width:3.47365236;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
    />
    <text
      xml:space="preserve"
      style="font-style:normal;font-weight:normal;font-size:40.05714035px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.2185185px;stroke-linecap:butt;stroke-linejoin:miter"
      x="-1754.8263"
      y="-445.67963"
      id="text9214"
      transform="matrix(-0.48558975,-1.1637738,0.7318564,-0.30537031,0,0)"
    >
      <tspan id="tspan9216" x="-1754.8263" y="-445.67963" style="stroke-width:1.2185185px">WC</tspan>
    </text>
    <g id="g-cottage-1-1">
      <path
        :style="{fill: getColor('cottage-1-1')}"
        d="m 286.98304,2300.2 -50.74701,-121.6245 -113.8653,47.5154 50.74698,121.6244 z"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.2185185px;stroke-linecap:butt;stroke-linejoin:miter"
        x="-704.28168"
        y="2181.9158"
        transform="rotate(-22.648553)"
      >
        <tspan
          id="tspan9144"
          x="-704.28168"
          y="2181.9158"
          style="font-size:45.5737915px;stroke-width:1.2185185px"
        >1</tspan>
      </text>
      <title>{{ getTitle('cottage-1-1') }}</title>
    </g>
    <g id="g-cottage-1-3">
      <path
        :style="{fill: getColor('cottage-1-3')}"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.47365236;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
        d="m 308.15882,2343.6469 -18.58832,-44.5491 -116.4834,48.6033 18.5883,44.5491 z"
      />
      <text
        y="2272.1287"
        x="-702.63306"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.2185185px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
        transform="rotate(-22.648553)"
      >
        <tspan
          style="font-size:45.5737915px;stroke-width:1.2185185px"
          y="2272.1287"
          x="-702.63306"
          id="tspan9148"
        >3</tspan>
      </text>
      <title>{{ getTitle('cottage-1-3') }}</title>
    </g>
    <g id="g-cottage-1-2">
      <path
        :style="{fill: getColor('cottage-1-2')}"
        d="m 286.98304,2300.2 218.20633,-91.0439 -50.75259,-121.6236 -218.20075,91.043 z"
        style="opacity:1;fill-opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none"
      />
      <text
        y="2181.8755"
        x="-523.99817"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.2185185px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
        transform="rotate(-22.648553)"
      >
        <tspan
          style="font-size:45.5737915px;stroke-width:1.2185185px"
          y="2181.8755"
          x="-523.99817"
          id="tspan9152"
        >2</tspan>
      </text>
      <title>{{ getTitle('cottage-1-2') }}</title>
    </g>
    <path
      style="fill:#ceeafe;fill-opacity:1;stroke:#ceeafe;stroke-width:12.15314388;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;marker-start:url(#marker5503)"
      d="M 1028.012,212.94174 2168.1424,9.1333074"
      id="path3514"
    />
    <text
      xml:space="preserve"
      style="font-style:normal;font-weight:normal;font-size:10.9376936px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#ceeafe;stroke:#ceeafe;stroke-width:2.84836197;fill-opacity:1;stroke-opacity:1;"
      x="1161.3257"
      y="393.59219"
      id="text3860"
      transform="rotate(-11.227762)"
    >
      <tspan
        sodipodi:role="line"
        id="tspan3858"
        x="1161.3257"
        y="393.59219"
        style="font-size:113.93447876px;line-height:0.30000001;fill:#ceeafe;stroke-width:2.84836197;fill-opacity:1;stroke:#ceeafe;stroke-opacity:1;"
      >Hotel</tspan>
    </text>
    <text
      xml:space="preserve"
      style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:113.93447876px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:2.84836197"
      x="2304.1287"
      y="1031.631"
      id="text1267"
    >
      <tspan
        sodipodi:role="line"
        id="tspan1265"
        x="2304.1287"
        y="1031.631"
        style="stroke-width:2.84836197"
      />
    </text>
    <rect
      style="fill:#ffffff;stroke:#bcbcff;stroke-width:9.20438099;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
      id="rect18816"
      width="957.49365"
      height="773.71063"
      x="41.460312"
      y="32.853256"
    />
    <text
      xml:space="preserve"
      style="font-style:normal;font-weight:normal;font-size:11.97489643px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;stroke:none;stroke-width:3.0196991"
      x="170.30545"
      y="114.28004"
      id="text16385"
    >
      <tspan
        sodipodi:role="line"
        id="tspan16383"
        x="170.30545"
        y="114.28004"
        style="font-size:56.36772156px;line-height:0.30000001;stroke-width:3.0196991"
      >1. patro</tspan>
    </text>
    <text
      id="text16389"
      y="110.21835"
      x="645.97394"
      style="font-style:normal;font-weight:normal;font-size:11.97489643px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;stroke:none;stroke-width:3.0196991"
      xml:space="preserve"
    >
      <tspan
        style="font-size:56.36772156px;line-height:0.30000001;stroke-width:3.0196991"
        y="110.21835"
        x="645.97394"
        id="tspan16387"
        sodipodi:role="line"
      >2. patro</tspan>
    </text>
    <rect
      style="fill:#ac9d93;fill-opacity:1;stroke:#000000;stroke-width:2.87779593;stroke-miterlimit:4;stroke-dasharray:none"
      id="rect15826"
      width="550.12012"
      height="45.324005"
      x="140.60997"
      y="-312.80109"
      transform="rotate(90)"
    />
    <rect
      y="-264.64005"
      x="141.00276"
      height="165.11052"
      width="78.636406"
      id="rect16038"
      style="fill:#ac9d93;stroke:#000000;stroke-width:2.79624939;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
      transform="rotate(90)"
    />
    <text
      transform="scale(1.0437059,0.95812431)"
      id="text16397"
      y="199.85674"
      x="108.47271"
      style="font-style:normal;font-weight:normal;font-size:11.97489643px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;stroke:none;stroke-width:0.90861666"
      xml:space="preserve"
    >
      <tspan
        style="font-size:36.34466934px;line-height:0.30000001;stroke-width:0.90861666"
        y="199.85674"
        x="108.47271"
        id="tspan16395"
        sodipodi:role="line"
      >schody</tspan>
    </text>
    <path
      sodipodi:nodetypes="ccccc"
      id="path4480"
      d="M 480.92564,693.1489 H 99.226111 c 0,21.07297 0,44.56361 0,62.49507 H 480.92564 c 0,-20.87922 0,-43.15036 0,-62.49507 z"
      style="fill:#ac9d93;fill-opacity:1;stroke:#000000;stroke-width:2.18939734;stroke-miterlimit:4;stroke-dasharray:none"
    />
    <text
      xml:space="preserve"
      style="font-style:normal;font-weight:normal;font-size:59.60649872px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.42614293px;stroke-linecap:butt;stroke-linejoin:miter"
      x="169.81468"
      y="939.7218"
      id="text4482"
      transform="matrix(1.2609798,-0.00983014,0.00618183,0.79298592,0,0)"
    >
      <tspan style="stroke-width:1.42614293px" id="tspan4484" x="169.81468" y="939.7218">WC</tspan>
    </text>
    <rect
      transform="rotate(90)"
      y="-779.60089"
      x="140.54207"
      height="45.324005"
      width="550.12012"
      id="rect4612"
      style="fill:#ac9d93;fill-opacity:1;stroke:#000000;stroke-width:2.87779593;stroke-miterlimit:4;stroke-dasharray:none"
    />
    <rect
      transform="rotate(90)"
      style="fill:#ac9d93;stroke:#000000;stroke-width:2.79624939;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
      id="rect4626"
      width="78.636406"
      height="165.11052"
      x="140.93486"
      y="-731.43988"
    />
    <text
      xml:space="preserve"
      style="font-style:normal;font-weight:normal;font-size:11.97489643px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;stroke:none;stroke-width:0.90861666"
      x="555.72504"
      y="199.78586"
      id="text4628"
      transform="scale(1.0437059,0.95812431)"
    >
      <tspan
        sodipodi:role="line"
        id="tspan4630"
        x="555.72504"
        y="199.78586"
        style="font-size:36.34466934px;line-height:0.30000001;stroke-width:0.90861666"
      >schody</tspan>
    </text>
    <path
      style="fill:#ac9d93;fill-opacity:1;stroke:#000000;stroke-width:2.18939734;stroke-miterlimit:4;stroke-dasharray:none"
      d="M 947.7255,693.08101 H 566.02595 c 0,21.07296 0,44.56361 0,62.49506 H 947.7255 c 0,-20.87923 0,-43.15036 0,-62.49506 z"
      id="path4684"
      sodipodi:nodetypes="ccccc"
    />
    <text
      transform="matrix(1.2609798,-0.00983014,0.00618183,0.79298592,0,0)"
      id="text4686"
      y="944.22491"
      x="539.98077"
      style="font-style:normal;font-weight:normal;font-size:59.60649872px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.42614293px;stroke-linecap:butt;stroke-linejoin:miter"
      xml:space="preserve"
    >
      <tspan y="944.22491" x="539.98077" id="tspan4688" style="stroke-width:1.42614293px">WC</tspan>
    </text>
    <g id="g-hotel_wc-31">
      <rect
        :style="{fill: getColor('hotel_wc-31')}"
        style="stroke:#000000;stroke-width:2.79519033;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
        width="78.636566"
        height="164.98515"
        x="140.74203"
        y="-947.42249"
        transform="rotate(90)"
      />
      <text
        transform="rotate(-0.04759499)"
        id="text4632"
        y="193.07996"
        x="857.38434"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        xml:space="preserve"
      >
        <tspan
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
          y="193.07996"
          x="857.38434"
          id="tspan4634"
        >31</tspan>
      </text>
      <text
        transform="matrix(0.00967432,-1.260981,0.79298668,0.00608384,0,0)"
        id="text4710"
        y="1016.3325"
        x="-161.36472"
        style="font-style:normal;font-weight:normal;font-size:29.32461739px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.42614293px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan y="1016.3325" x="-161.36472" id="tspan4712" style="stroke-width:1.42614293px">WC</tspan>
      </text>
      <title>{{ getTitle('hotel_wc-31') }}</title>
    </g>
    <g id="g-hotel-42">
      <rect
        :style="{fill: getColor('hotel-42')}"
        style="stroke:#000000;stroke-width:2.79624939;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
        width="78.636406"
        height="165.11052"
        x="533.39026"
        y="-731.43988"
        transform="rotate(90)"
      />
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        x="624.49323"
        y="585.6311"
        id="text4676"
        transform="rotate(-0.04759499)"
      >
        <tspan
          id="tspan4678"
          x="624.49323"
          y="585.6311"
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        >42</tspan>
      </text>
      <title>{{ getTitle('hotel-42') }}</title>
    </g>
    <g id="g-hotel-41">
      <rect
        :style="{fill: getColor('hotel-41')}"
        y="-731.43988"
        x="611.95178"
        height="165.11052"
        width="78.636406"
        style="stroke:#000000;stroke-width:2.79624939;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
        transform="rotate(90)"
      />
      <text
        transform="rotate(-0.04759499)"
        id="text4680"
        y="664.21436"
        x="624.70929"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        xml:space="preserve"
      >
        <tspan
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
          y="664.21436"
          x="624.70929"
          id="tspan4682"
        >41</tspan>
      </text>
      <title>{{ getTitle('hotel-41') }}</title>
    </g>
    <g id="g-special-35-1">
      <path
        :style="{fill: getColor('special-35-1')}"
        d="m 782.43881,376.40439 v 59.05772 h 164.97828 v -59.05772 z"
        style="fill-opacity:1;stroke:#000000;stroke-width:2.79375434;stroke-miterlimit:4;stroke-dasharray:2.79375423, 5.58750849;stroke-dashoffset:0"
      />
      <text
        transform="rotate(-0.04759499)"
        id="text4648"
        y="416.70883"
        x="831.12842"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        xml:space="preserve"
      >
        <tspan
          style="font-size:33.88244629px;fill:#000000;stroke:none;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
          y="416.70883"
          x="831.12842"
          id="tspan4650"
        >35-1</tspan>
      </text>
      <title>{{ getTitle('special-35-1') }}</title>
    </g>
    <g id="g-hotel-36">
      <rect
        :style="{fill: getColor('hotel-36')}"
        style="stroke:#000000;stroke-width:2.79519033;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
        width="78.636566"
        height="164.98515"
        x="611.95215"
        y="-947.42249"
        transform="rotate(90)"
      />
      <text
        transform="rotate(-0.04759499)"
        id="text4656"
        y="664.39734"
        x="844.49823"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        xml:space="preserve"
      >
        <tspan
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
          y="664.39734"
          x="844.49823"
          id="tspan4658"
        >36</tspan>
      </text>
      <title>{{ getTitle('hotel-36') }}</title>
    </g>
    <g id="g-hotel_wc-14">
      <rect
        :style="{fill: getColor('hotel_wc-14')}"
        transform="rotate(90)"
        style="stroke:#000000;stroke-width:2.79414678;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
        width="78.636566"
        height="164.98515"
        x="219.44647"
        y="-480.62277"
      />
      <text
        transform="rotate(-0.04759499)"
        y="271.44086"
        x="390.06451"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        xml:space="preserve"
      >
        <tspan
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
          y="271.44086"
          x="390.06451"
          id="tspan16411"
        >14</tspan>
      </text>
      <text
        transform="matrix(0.00967432,-1.260981,0.79298668,0.00608384,0,0)"
        id="text4516"
        y="428.47986"
        x="-227.56487"
        style="font-style:normal;font-weight:normal;font-size:29.32461739px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.42614293px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan y="428.47986" x="-227.56487" id="tspan4518" style="stroke-width:1.42614293px">WC</tspan>
      </text>
      <title>{{ getTitle('hotel_wc-14') }}</title>
    </g>
    <g id="g-hotel_wc-16">
      <rect
        :style="{fill: getColor('hotel_wc-16')}"
        transform="rotate(90)"
        y="-480.62277"
        x="297.96121"
        height="164.98515"
        width="78.636566"
        style="fill-opacity:1;stroke:#000000;stroke-width:2.79519033;stroke-miterlimit:4;stroke-dasharray:none"
      />
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        x="390.09833"
        y="349.9281"
        transform="rotate(-0.04759499)"
      >
        <tspan
          id="tspan16415"
          x="390.09833"
          y="349.9281"
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        >16</tspan>
      </text>
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:29.32461739px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.42614293px;stroke-linecap:butt;stroke-linejoin:miter"
        x="-290.9978"
        y="429.25375"
        id="text4520"
        transform="matrix(0.00967432,-1.260981,0.79298668,0.00608384,0,0)"
      >
        <tspan style="stroke-width:1.42614293px" id="tspan4522" x="-290.9978" y="429.25375">WC</tspan>
      </text>
      <title>{{ getTitle('hotel_wc-16') }}</title>
    </g>
    <g id="g-hotel_wc-13">
      <rect
        :style="{fill: getColor('hotel_wc-13')}"
        transform="rotate(90)"
        y="-480.62277"
        x="140.80994"
        height="164.98515"
        width="78.636566"
        style="stroke:#000000;stroke-width:2.79519033;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        x="390.58463"
        y="192.76007"
        transform="rotate(-0.04759499)"
      >
        <tspan
          id="tspan16407"
          x="390.58463"
          y="192.76007"
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        >13</tspan>
      </text>
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:29.32461739px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.42614293px;stroke-linecap:butt;stroke-linejoin:miter"
        x="-164.2585"
        y="427.70752"
        id="text4512"
        transform="matrix(0.00967432,-1.260981,0.79298668,0.00608384,0,0)"
      >
        <tspan style="stroke-width:1.42614293px" id="tspan4514" x="-164.2585" y="427.70752">WC</tspan>
      </text>
      <title>{{ getTitle('hotel_wc-13') }}</title>
    </g>
    <g id="g-hotel_wc-30">
      <rect
        :style="{fill: getColor('hotel_wc-30')}"
        transform="rotate(90)"
        y="-264.64005"
        x="219.49385"
        height="165.11052"
        width="78.636406"
        style="fill-opacity:1;stroke:#000000;stroke-width:2.79624939;stroke-miterlimit:4;stroke-dasharray:none"
      />
      <text
        transform="rotate(-0.04759499)"
        y="271.24332"
        x="144.79779"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        xml:space="preserve"
      >
        <tspan
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
          y="271.24332"
          x="144.79779"
          id="tspan16597"
        >30</tspan>
      </text>
      <text
        transform="matrix(0.00967432,-1.260981,0.79298668,0.00608384,0,0)"
        id="text4494"
        y="330.14325"
        x="-230.68484"
        style="font-style:normal;font-weight:normal;font-size:29.32461739px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.42614293px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan y="330.14325" x="-230.68484" id="tspan4496" style="stroke-width:1.42614293px">WC</tspan>
      </text>
      <title>{{ getTitle('hotel_wc-30') }}</title>
    </g>
    <g id="g-hotel_wc-29">
      <rect
        :style="{fill: getColor('hotel_wc-29')}"
        transform="rotate(90)"
        style="fill-opacity:1;stroke:#000000;stroke-width:2.79624939;stroke-miterlimit:4;stroke-dasharray:none"
        width="78.636406"
        height="165.11052"
        x="297.98492"
        y="-264.64005"
      />
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        x="144.78218"
        y="349.7807"
        transform="rotate(-0.04759499)"
      >
        <tspan
          id="tspan16601"
          x="144.78218"
          y="349.7807"
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        >29</tspan>
      </text>
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:29.32461739px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.42614293px;stroke-linecap:butt;stroke-linejoin:miter"
        x="-293.99124"
        y="330.91559"
        id="text4498"
        transform="matrix(0.00967432,-1.260981,0.79298668,0.00608384,0,0)"
      >
        <tspan style="stroke-width:1.42614293px" id="tspan4500" x="-293.99124" y="330.91559">WC</tspan>
      </text>
      <title>{{ getTitle('hotel_wc-29') }}</title>
    </g>
    <g id="g-hotel_wc-27">
      <rect
        :style="{fill: getColor('hotel_wc-27')}"
        y="-264.64005"
        x="454.9671"
        height="165.11052"
        width="78.636406"
        style="fill-opacity:1;stroke:#000000;stroke-width:2.79624939;stroke-miterlimit:4;stroke-dasharray:none"
        transform="rotate(90)"
      />
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:29.32461739px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.42614293px;stroke-linecap:butt;stroke-linejoin:miter"
        x="-415.32837"
        y="332.39594"
        id="text4506"
        transform="matrix(0.00967432,-1.260981,0.79298668,0.00608384,0,0)"
      >
        <tspan style="stroke-width:1.42614293px" id="tspan4508" x="-415.32837" y="332.39594">WC</tspan>
      </text>
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        x="144.6021"
        y="507.03558"
        transform="rotate(-0.04759499)"
      >
        <tspan
          id="tspan16609"
          x="144.6021"
          y="507.03558"
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        >27</tspan>
      </text>
      <title>{{ getTitle('hotel_wc-27') }}</title>
    </g>
    <g id="g-hotel_wc-28">
      <rect
        :style="{fill: getColor('hotel_wc-28')}"
        transform="rotate(90)"
        y="-264.64005"
        x="376.47601"
        height="165.11052"
        width="78.636406"
        style="fill:#bcbcff;fill-opacity:1;stroke:#000000;stroke-width:2.79624939;stroke-miterlimit:4;stroke-dasharray:none"
      />
      <text
        transform="rotate(-0.04759499)"
        y="428.28464"
        x="144.60938"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        xml:space="preserve"
      >
        <tspan
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
          y="428.28464"
          x="144.60938"
          id="tspan16605"
        >28</tspan>
      </text>
      <text
        transform="matrix(0.00967432,-1.260981,0.79298668,0.00608384,0,0)"
        id="text4502"
        y="331.63437"
        x="-352.90674"
        style="font-style:normal;font-weight:normal;font-size:29.32461739px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.42614293px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan y="331.63437" x="-352.90674" id="tspan4504" style="stroke-width:1.42614293px">WC</tspan>
      </text>
      <title>{{ getTitle('hotel_wc-28') }}</title>
    </g>
    <g id="g-hotel-26">
      <rect
        :style="{fill: getColor('hotel-26')}"
        transform="rotate(90)"
        y="-264.64005"
        x="533.45819"
        height="165.11052"
        width="78.636406"
        style="stroke:#000000;stroke-width:2.79624939;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        transform="rotate(-0.04759499)"
        y="585.31116"
        x="157.69345"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        xml:space="preserve"
      >
        <tspan
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
          y="585.31116"
          x="157.69345"
          id="tspan16613"
        >26</tspan>
      </text>
      <title>{{ getTitle('hotel-26') }}</title>
    </g>
    <g id="g-hotel-25">
      <rect
        :style="{fill: getColor('hotel-25')}"
        transform="rotate(90)"
        style="stroke:#000000;stroke-width:2.79624939;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
        width="78.636406"
        height="165.11052"
        x="612.01971"
        y="-264.64005"
      />
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        x="157.90939"
        y="663.89441"
        transform="rotate(-0.04759499)"
      >
        <tspan
          id="tspan16617"
          x="157.90939"
          y="663.89441"
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        >25</tspan>
      </text>
      <title>{{ getTitle('hotel-25') }}</title>
    </g>
    <g id="g-hotel-20">
      <rect
        :style="{fill: getColor('hotel-20')}"
        transform="rotate(90)"
        y="-480.62277"
        x="612.02008"
        height="164.98515"
        width="78.636566"
        style="fill:#ceeafe;stroke:#000000;stroke-width:2.79519033;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        x="377.69843"
        y="664.07739"
        transform="rotate(-0.04759499)"
      >
        <tspan
          id="tspan16431"
          x="377.69843"
          y="664.07739"
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        >20</tspan>
      </text>
      <title>{{ getTitle('hotel-20') }}</title>
    </g>
    <g id="g-hotel-19">
      <rect
        :style="{fill: getColor('hotel-19')}"
        transform="rotate(90)"
        style="stroke:#000000;stroke-width:2.79519033;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
        width="78.636566"
        height="164.98515"
        x="533.50537"
        y="-480.62277"
      />
      <text
        transform="rotate(-0.04759499)"
        y="586.12469"
        x="376.7952"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        xml:space="preserve"
      >
        <tspan
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
          y="586.12469"
          x="376.7952"
          id="tspan16427"
        >19</tspan>
      </text>
      <title>{{ getTitle('hotel-19') }}</title>
    </g>
    <g id="g-hotel-18">
      <rect
        :style="{fill: getColor('hotel-18')}"
        transform="rotate(90)"
        y="-480.62277"
        x="454.99066"
        height="164.98515"
        width="78.636566"
        style="fill:#ceeafe;stroke:#000000;stroke-width:2.79519033;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        x="376.75333"
        y="507.01324"
        transform="rotate(-0.04759499)"
      >
        <tspan
          id="tspan16423"
          x="376.75333"
          y="507.01324"
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        >18</tspan>
      </text>
      <title>{{ getTitle('hotel-18') }}</title>
    </g>
    <g id="g-hotel-17">
      <rect
        :style="{fill: getColor('hotel-17')}"
        transform="rotate(90)"
        style="stroke:#000000;stroke-width:2.79519033;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
        width="78.636566"
        height="164.98515"
        x="376.47589"
        y="-480.62277"
      />
      <text
        transform="rotate(-0.04759499)"
        y="428.50137"
        x="376.87671"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        xml:space="preserve"
      >
        <tspan
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
          y="428.50137"
          x="376.87671"
          id="tspan16419"
        >17</tspan>
      </text>
      <title>{{ getTitle('hotel-17') }}</title>
    </g>
    <g id="g-cottage-5-1">
      <path
        :style="{fill: getColor('cottage-5-1')}"
        d="m 881.88005,1039.1857 2.95731,-131.75534 -116.47718,-2.61429 -2.9573,131.75523 z"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        transform="rotate(1.2858115)"
        y="971.7597"
        x="826.91888"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261767px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan
          style="font-size:45.5737915px;stroke-width:1.30261767px"
          y="971.7597"
          x="826.91888"
          id="tspan7271"
        >1</tspan>
      </text>
      <title>{{ getTitle('cottage-5-1') }}</title>
    </g>
    <g id="g-cottage-5-2">
      <path
        :style="{fill: getColor('cottage-5-2')}"
        d="m 1006.7761,910.31736 -122.04736,-2.73943 -2.9573,131.75537 122.30096,2.523 z"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        transform="rotate(1.2858115)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261767px;stroke-linecap:butt;stroke-linejoin:miter"
        x="946.46558"
        y="971.96643"
      >
        <tspan
          id="tspan7275"
          x="946.46558"
          y="971.96643"
          style="font-size:45.5737915px;stroke-width:1.30261767px"
        >2</tspan>
      </text>
      <title>{{ getTitle('cottage-5-2') }}</title>
    </g>
    <g id="g-cottage-5-3">
      <path
        :style="{fill: getColor('cottage-5-3')}"
        d="m 1006.8847,910.1698 -2.9571,131.7554 121.1995,2.7203 2.9573,-131.75532 z"
        style="opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:3.4736526;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:3.5999999;stroke-dasharray:none;fill-opacity:1"
      />
      <text
        transform="rotate(1.2858115)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.30261767px;stroke-linecap:butt;stroke-linejoin:miter"
        x="1068.2389"
        y="971.71997"
      >3</text>
      <title>{{ getTitle('cottage-5-3') }}</title>
    </g>
    <path
      id="path4510"
      d="M 344.16001,139.17107 V 377.99535"
      style="fill:none;fill-rule:evenodd;stroke:#000000;stroke-width:2.44845676;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
    />
    <path
      style="fill:none;fill-rule:evenodd;stroke:#000000;stroke-width:2.79414678;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
      d="M 237.62735,222.3399 V 533.3626"
      id="path4492"
    />
    <g id="g-hotel_wc-46">
      <rect
        :style="{fill: getColor('hotel_wc-46')}"
        style="stroke:#000000;stroke-width:2.79624939;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
        width="78.636406"
        height="165.11052"
        x="219.42595"
        y="-731.43988"
        transform="rotate(90)"
      />
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        x="611.59766"
        y="271.56317"
        id="text4660"
        transform="rotate(-0.04759499)"
      >
        <tspan
          id="tspan4662"
          x="611.59766"
          y="271.56317"
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        >46</tspan>
      </text>
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:29.32461739px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.42614293px;stroke-linecap:butt;stroke-linejoin:miter"
        x="-226.74985"
        y="920.47748"
        id="text4692"
        transform="matrix(0.00967432,-1.260981,0.79298668,0.00608384,0,0)"
      >
        <tspan style="stroke-width:1.42614293px" id="tspan4694" x="-226.74985" y="920.47748">WC</tspan>
      </text>
      <title>{{ getTitle('hotel_wc-46') }}</title>
    </g>
    <g id="g-hotel_wc-45">
      <rect
        :style="{fill: getColor('hotel_wc-45')}"
        y="-731.43988"
        x="297.91702"
        height="165.11052"
        width="78.636406"
        style="stroke:#000000;stroke-width:2.79624939;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
        transform="rotate(90)"
      />
      <text
        transform="rotate(-0.04759499)"
        id="text4664"
        y="350.10056"
        x="611.58203"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        xml:space="preserve"
      >
        <tspan
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
          y="350.10056"
          x="611.58203"
          id="tspan4666"
        >45</tspan>
      </text>
      <text
        transform="matrix(0.00967432,-1.260981,0.79298668,0.00608384,0,0)"
        id="text4696"
        y="921.25"
        x="-290.05615"
        style="font-style:normal;font-weight:normal;font-size:29.32461739px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.42614293px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan y="921.25" x="-290.05615" id="tspan4698" style="stroke-width:1.42614293px">WC</tspan>
      </text>
      <title>{{ getTitle('hotel_wc-45') }}</title>
    </g>
    <g id="g-hotel_wc-44">
      <rect
        :style="{fill: getColor('hotel_wc-44')}"
        style="stroke:#000000;stroke-width:2.79624939;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
        width="78.636406"
        height="165.11052"
        x="376.40814"
        y="-731.43988"
        transform="rotate(90)"
      />
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        x="611.40924"
        y="428.60452"
        id="text4668"
        transform="rotate(-0.04759499)"
      >
        <tspan
          id="tspan4670"
          x="611.40924"
          y="428.60452"
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        >44</tspan>
      </text>
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:29.32461739px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.42614293px;stroke-linecap:butt;stroke-linejoin:miter"
        x="-348.97168"
        y="921.96863"
        id="text4700"
        transform="matrix(0.00967432,-1.260981,0.79298668,0.00608384,0,0)"
      >
        <tspan style="stroke-width:1.42614293px" id="tspan4702" x="-348.97168" y="921.96863">WC</tspan>
      </text>
      <title>{{ getTitle('hotel_wc-44') }}</title>
    </g>
    <g id="g-hotel_wc-43">
      <rect
        :style="{fill: getColor('hotel_wc-43')}"
        y="-731.43988"
        x="454.8992"
        height="165.11052"
        width="78.636406"
        style="stroke:#000000;stroke-width:2.79624939;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
        transform="rotate(90)"
      />
      <text
        transform="rotate(-0.04759499)"
        id="text4672"
        y="507.35547"
        x="611.40192"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        xml:space="preserve"
      >
        <tspan
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
          y="507.35547"
          x="611.40192"
          id="tspan4674"
        >43</tspan>
      </text>
      <text
        transform="matrix(0.00967432,-1.260981,0.79298668,0.00608384,0,0)"
        id="text4704"
        y="922.73016"
        x="-411.39331"
        style="font-style:normal;font-weight:normal;font-size:29.32461739px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.42614293px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan y="922.73016" x="-411.39331" id="tspan4706" style="stroke-width:1.42614293px">WC</tspan>
      </text>
      <title>{{ getTitle('hotel_wc-43') }}</title>
    </g>
    <g id="g-hotel_wc-33">
      <rect
        :style="{fill: getColor('hotel_wc-33')}"
        y="-947.42249"
        x="219.37857"
        height="164.98515"
        width="78.636566"
        style="stroke:#000000;stroke-width:2.79414678;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
        transform="rotate(90)"
      />
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        x="856.86432"
        y="271.76071"
        id="text4636"
        transform="rotate(-0.04759499)"
      >
        <tspan
          id="tspan4638"
          x="856.86432"
          y="271.76071"
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        >33</tspan>
      </text>
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:29.32461739px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.42614293px;stroke-linecap:butt;stroke-linejoin:miter"
        x="-224.67111"
        y="1017.1049"
        id="text4714"
        transform="matrix(0.00967432,-1.260981,0.79298668,0.00608384,0,0)"
      >
        <tspan style="stroke-width:1.42614293px" id="tspan4716" x="-224.67111" y="1017.1049">WC</tspan>
      </text>
      <title>{{ getTitle('hotel_wc-33') }}</title>
    </g>
    <g id="g-hotel_wc-34">
      <rect
        :style="{fill: getColor('hotel_wc-34')}"
        style="stroke:#000000;stroke-width:2.79519033;stroke-miterlimit:4;stroke-dasharray:none;fill-opacity:1"
        width="78.636566"
        height="164.98515"
        x="297.89334"
        y="-947.42249"
        transform="rotate(90)"
      />
      <text
        transform="rotate(-0.04759499)"
        id="text4640"
        y="350.24796"
        x="856.89807"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        xml:space="preserve"
      >
        <tspan
          style="font-size:33.88244629px;fill:#000000;stroke:#000000;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
          y="350.24796"
          x="856.89807"
          id="tspan4642"
        >34</tspan>
      </text>
      <text
        transform="matrix(0.00967432,-1.260981,0.79298668,0.00608384,0,0)"
        id="text4718"
        y="1017.8787"
        x="-288.104"
        style="font-style:normal;font-weight:normal;font-size:29.32461739px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.42614293px;stroke-linecap:butt;stroke-linejoin:miter"
        xml:space="preserve"
      >
        <tspan y="1017.8787" x="-288.104" id="tspan4720" style="stroke-width:1.42614293px">WC</tspan>
      </text>
      <title>{{ getTitle('hotel_wc-34') }}</title>
    </g>
    <path
      id="path4690"
      d="M 705.79274,220.9694 V 531.99208"
      style="fill:none;fill-rule:evenodd;stroke:#000000;stroke-width:2.79414678;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
    />
    <path
      style="fill:none;fill-rule:evenodd;stroke:#000000;stroke-width:2.44845676;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
      d="M 810.95983,139.10317 V 377.92745"
      id="path4708"
    />
    <g id="g-special-35-2">
      <path
        :style="{fill: getColor('special-35-2')}"
        transform="matrix(3.1250048,0,0,3.1250048,-0.00258294,0)"
        id="path5005"
        d="M 303.17383 139.34766 L 250.38086 139.34766 L 250.38086 145.57617 L 250.38086 145.61328 L 250.38086 158.28516 L 303.17383 158.28516 L 303.17383 145.61328 L 303.17383 145.57617 L 303.17383 139.34766 z "
        style="fill-opacity:1;stroke:none;stroke-width:0.89445954;stroke-miterlimit:4;stroke-dasharray:0.89445954, 0.89445954000000005;stroke-dashoffset:0"
      />
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        x="831.07904"
        y="476.11954"
        id="text4933"
        transform="rotate(-0.04759499)"
      >
        <tspan
          id="tspan4931"
          x="831.07904"
          y="476.11954"
          style="font-size:33.88244629px;fill:#000000;stroke:none;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        >35-2</tspan>
      </text>
      <title>{{ getTitle('special-35-2') }}</title>
    </g>
    <g id="g-special-35-4">
      <path
        :style="{fill: getColor('special-35-4')}"
        transform="matrix(3.1250048,0,0,3.1250048,-0.00258294,0)"
        id="path5010"
        d="M 303.17383 177.18359 L 250.38086 177.18359 L 250.38086 195.86328 L 303.17383 195.86328 L 303.17383 177.18359 z "
        style="fill-opacity:1;stroke:none;stroke-width:0.89445954;stroke-miterlimit:4;stroke-dasharray:0.89445954, 0.89445954000000005;stroke-dashoffset:0"
      />
      <text
        transform="rotate(-0.04759499)"
        id="text4937"
        y="596.79901"
        x="831.36493"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        xml:space="preserve"
      >
        <tspan
          style="font-size:33.88244629px;fill:#000000;stroke:none;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
          y="596.79901"
          x="831.36493"
          id="tspan4935"
        >35-4</tspan>
      </text>
      <title>{{ getTitle('special-35-4') }}</title>
    </g>
    <g id="g-special-35-3">
      <path
        :style="{fill: getColor('special-35-3')}"
        transform="matrix(3.1250048,0,0,3.1250048,-0.00258294,0)"
        id="path4987"
        d="M 250.38086 158.28516 L 250.38086 170.73828 L 250.38086 177.18359 L 303.17383 177.18359 L 303.17383 170.70117 L 303.17383 158.28516 L 250.38086 158.28516 z "
        style="fill-opacity:1;stroke:#000000;stroke-width:0.89399998;stroke-miterlimit:4;stroke-dasharray:0.89399998,1.78799997;stroke-dashoffset:0"
      />
      <text
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:180.70640564px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:#000000;stroke-width:2.49477386;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        x="831.02911"
        y="536.22949"
        id="text4941"
        transform="rotate(-0.04759499)"
      >
        <tspan
          id="tspan4939"
          x="831.02911"
          y="536.22949"
          style="font-size:33.88244629px;fill:#000000;stroke:none;stroke-width:2.49477386;stroke-miterlimit:4;stroke-dasharray:none;paint-order:stroke markers fill"
        >35-3</tspan>
      </text>
      <title>{{ getTitle('special-35-3') }}</title>
    </g>
    <rect
      style="opacity:1;fill:none;fill-opacity:1;stroke:#000000;stroke-width:2.79375426;stroke-linecap:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
      id="rect5012"
      width="164.98517"
      height="235.42224"
      x="782.43732"
      y="376.52991"
    />
    <rect
      y="1956.0112"
      x="2044.6903"
      height="329.93036"
      width="885.81921"
      id="rect5211"
      style="opacity:1;fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:2.42607021;stroke-linecap:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
    />
    <rect
      y="2022.3411"
      x="2102.8267"
      height="69.541649"
      width="125.17496"
      id="rect5195"
      style="opacity:1;fill:#b8e854;fill-opacity:1;stroke:#000000;stroke-width:2.79375434;stroke-linecap:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
    />
    <rect
      style="opacity:1;fill:#ff0000;fill-opacity:1;stroke:#000000;stroke-width:2.79375434;stroke-linecap:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
      id="rect5197"
      width="125.17496"
      height="69.541649"
      x="2102.8267"
      y="2147.3411"
    />
    <text
      id="text5201"
      y="2081.2649"
      x="2265.7664"
      style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:100.00015259px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:3.12500477"
      xml:space="preserve"
    >
      <tspan
        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:Calibri;stroke-width:3.12500477"
        y="2081.2649"
        x="2265.7664"
        id="tspan5199"
        sodipodi:role="line"
      >můj pokoj</tspan>
    </text>
    <text
      xml:space="preserve"
      style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:100.00015259px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:3.12500477"
      x="2264.3625"
      y="2208.2444"
      id="text5209"
    >
      <tspan
        sodipodi:role="line"
        id="tspan5207"
        x="2264.3625"
        y="2208.2444"
        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-family:Calibri;stroke-width:3.12500477"
      >obsazený pokoj</tspan>
    </text>
    <g id="g-special-12-5">
      <path
        :style="{fill: getColor('special-12-5')}"
        d="m 1259.354,464.5616 -4.4188,110.44564 159.3377,6.30194 13.2605,0.52618 3.8837,-111.31451 z"
        style="font-style:normal;font-weight:400;font-size:medium;font-family:'MS Shell Dlg 2';fill-opacity:1;fill-rule:evenodd;stroke-width:3.39586449;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:4;stroke-dasharray:none"
      />
      <text
        transform="rotate(1.9980188)"
        xml:space="preserve"
        style="font-style:normal;font-weight:normal;font-size:45.5737915px;line-height:0%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-rule:evenodd;stroke:none;stroke-width:1.32319987px;stroke-linecap:butt;stroke-linejoin:miter"
        x="1344.1395"
        y="491.36057"
      >
        <tspan
          id="tspan6065"
          x="1344.1395"
          y="491.36057"
          style="font-size:45.5737915px;stroke-width:1.32319987px"
        >5</tspan>
      </text>
      <title>{{ getTitle('special-12-5') }}</title>
    </g>
    <path
      style="fill:none;stroke:#000000;stroke-width:6.6587081;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none"
      d="m 1429.5067,404.63517 -6.1792,177.04174"
      id="path2109"
    />
    <path
      style="fill:#ceeafe;fill-opacity:1;fill-rule:evenodd;stroke:#ceeafe;stroke-width:3.3333385px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
      d="m 1007.9363,216.54245 140.8883,-82.49273 c -9.1032,58.03746 -9.8684,58.10007 20.0203,111.43455 z"
      id="path4636"
      sodipodi:nodetypes="cccc"
    />
  </svg>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "mapSchema",
  computed: {
    ...mapState(["login", "outpost", "accommodation"])
  },
  methods: {
    clicked(event) {
      var element = event.target;
      while (
        element != null &&
        (element.id == null || !element.id.startsWith("g-"))
      ) {
        element = element.parentElement;
      }
      if (element == null) return;

      var location = element.id.substr(2);
      var acc = this.accommodation[location];
      if (acc.outpostId == null && !acc.isReservedByAdmin) this.$emit("addAcc", { id: location });
      else if (acc.outpostId == this.outpost.id)
        this.$emit("removeAcc", { id: location });
    },
    getColor(accommodationId) {
      var acc = this.accommodation[accommodationId];
      if (acc === undefined) return "#ff0000";

      // reserved by admin
      if (acc.isReservedByAdmin) return "#ff0000";

      // available
      if (acc.outpostId == null) {
        switch (accommodationId.split("-")[0]) {
          case "hotel_wc":
            return "#bcbcff";
          case "hotel":
            return "#ceeafe";
          case "cottage":
            return "#dcc59b";
          case "hut":
            return "#fdea90";
          case "special":
            return "#fefbad";
          default:
            return "#ffffff";
        }
      }

      // my
      if (acc.outpostId == this.outpost.id) return "#b8e854";

      // other
      return "#ff0000";
    },
    getTitle(accommodationId) {
      const acc = this.accommodation[accommodationId];
      if (acc == null) return;

      if (acc.isReservedByAdmin)
        return `Obsazeno: Organizátoři; ${acc.description}; ${acc.price} Kč`;

      if (acc.outpostId != null)
        return `Obsazeno: ${acc.outpostId}. PH; ${acc.description}; ${acc.price} Kč`;

      return `${acc.description}; ${acc.price} Kč`;
    }
  }
};
</script>

<style lang="sass">
svg#map_schema
  stroke: #000000
</style>
